
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import url from "@/views/paper/paper-result-report/assets/reading-guide.png";

@Component
export default class HoverImage extends Vue {
  // 定义 props
  @Prop({ required: false }) imgSrc!: string;
  @Prop({ default: "" }) imgClass!: string;
  @Prop({ default: "image" }) imgAlt!: string;

  defaultUrl = url;
  // 计算组合后的类名
  get computedClass(): string[] {
    return ["reading-guide", this.imgClass];
  }
  // 事件处理方法并发出事件
  @Emit("hover")
  handleMouseEnter(): boolean {
    return true; // 传递给父组件的事件值
  }

  @Emit("hover")
  handleMouseLeave(): boolean {
    return false; // 传递给父组件的事件值
  }
}
